import { requestWrapper } from '@/utils/axiosInstance';

const API_DEVELOPER = `${process.env.VUE_APP_API_MAIN}/developer`;

export default {
  async getInfo(obj) {
    return await requestWrapper(API_DEVELOPER, 'POST', `/classifiers_classes_information`, null, obj);
  },
};
